import React, { ReactElement } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

export default function (): ReactElement {
  return (
    <div
      style={{
        color: '#222',
        display: 'flex',
        width: '100%',
        height: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 45,
        backgroundColor: '#ecf0f5',
      }}
    >
      <FontAwesomeIcon icon={faSpinner} spin />
    </div>
  );
}
